import { CommonProgressData } from "../LTGame/Commom/CommonProgressData";
import { EPlatformType } from "../LTGame/Platform/EPlatformType";
import LTPlatform from "../LTGame/Platform/LTPlatform";
import LTRespackManager from "../LTGame/Res/LTRespackManager";
import { LTStart } from "../LTGame/Start/LTStart";
import SDK_CQ from "../SDK/Impl/SDK_CQ";
import SDK_Default from "../SDK/Impl/SDK_Default";
import LTSDK from "../SDK/LTSDK";
import GameData from "./common/GameData";
import MainScene from "./scene/MainScene";
import SplashScene from "./scene/SplashScene";
export default class MainStart extends LTStart {
    constructor() {
        super();
        this._appId = "";
        /**SDK云控版本名 */
        this._gameVersion = "1.0.0";
        /**资源版本 */
        this._resVersion = "0515";
        /**项目名 */
        this._gameName = "p_fkjh";
        this._remoteUrl = "https://file.gugudang.com";
        this.enableStat = false;
    }
    _HandleInitPlatform(ePlatform, platformData) {
        // window["__GM"] = 1;
        GameData.SAVE_NAME = this._gameName + '.sav';
        CommonProgressData.Init(this._gameName + '.progress');
        switch (ePlatform) {
            case EPlatformType.Web:
                console.log("web平台,默认框架测试数据");
                this._gameVersion = '0.0.0'; //1.0.1 为全策略模式 
                platformData.appId = "tt08657ed8975bfeb102"; //'88888888';
                platformData.appKey = '11111111111';
                break;
            case EPlatformType.TT:
                this._gameVersion = "0.2.3";
                this._resVersion = '231030_0';
                platformData.appId = "tt08657ed8975bfeb102";
                platformData.bannerId = "oha8lfo1mr4731gfm6";
                platformData.rewardVideoId = "6k8ge1bdjj8b4knkch";
                platformData.interstitialId = "4ab0knwk4qs3i459a1";
                LTRespackManager.instance.SetRemoteUrl(`${this._remoteUrl}/res/down/public/${this._gameName}/${this._resVersion}_tt/`);
                break;
            case EPlatformType.WX:
                this._gameVersion = "0.0.2";
                this._resVersion = '220805';
                platformData.appId = "wx94bc51dcc9264e47";
                platformData.bannerId = "adunit-a1eae368fcabd27d";
                platformData.rewardVideoId = "adunit-84b6bd02b7d1de58";
                platformData.interstitialId = "adunit-97f6594b4bf12067";
                platformData.gameBoxAdId = "adunit-6a1a1f07e1d9fc76";
                platformData.gameBoxBannerId = "adunit-ba68a9b7cd35a2a9";
                platformData.nativeinpageIds = ["adunit-e8804ff610d86d9f", "adunit-f1cec49faf5b049e"];
                // platformData.="adunit-5b331ccc3d1112e6";
                LTRespackManager.instance.SetRemoteUrl(`${this._remoteUrl}/res/down/public/${this._gameName}/${this._resVersion}_wx/`);
                break;
            case EPlatformType.Oppo:
                this._gameVersion = "0.0.1";
                this._resVersion = "0710";
                platformData.appId = "30819113";
                platformData.appKey = "8ENxjsrM59Oo4GG0wKoS84c8w";
                platformData.bannerId = "535336";
                platformData.rewardVideoId = "535342";
                platformData.gameBoxAdId = "535343";
                platformData.gameBoxBannerId = "535344";
                platformData.nativeinpageIds = ['535339', '535341'];
                platformData.nativeId = "535341";
                LTRespackManager.instance.SetRemoteUrl(`${this._remoteUrl}/res/down/public/${this._gameName}/${this._resVersion}_oppo/`);
                break;
            case EPlatformType.Vivo:
                this._gameVersion = "0.0.0";
                this._resVersion = "220531";
                platformData.appId = "105564409";
                platformData.appKey = "105564409"; // "4593206c07a95b1edf85";
                platformData.bannerId = "c2da47029f30424ca3074f94932b7bdb";
                platformData.rewardVideoId = "7b3c92c68421417a92c7cefc551213ba";
                platformData.interstitialId = "";
                platformData.nativeinpageIds = ['db52da0c76a8497c95e732ca2d1c3d28', 'c0873d80df654e87be47e82421f78bb2'];
                platformData.nativeId = "c0873d80df654e87be47e82421f78bb2";
                platformData.gameBoxAdId = "0e9f57ddc2584bd1a36eac7136d4d3f5";
                platformData.gameBoxBannerId = "20eabb82c12b439b82d2f9274b0101d9";
                LTRespackManager.instance.SetRemoteUrl(`${this._remoteUrl}/res/down/public/${this._gameName}/vivo_${this._resVersion}/`);
                break;
            case EPlatformType.KS:
                this._gameVersion = "0.0.1";
                this._resVersion = "0.0.1";
                platformData.appId = "ks667940122780561072";
                platformData.rewardVideoId = "2300737_01";
                platformData.interstitialId = "230737_02";
                LTRespackManager.instance.SetRemoteUrl(`${this._remoteUrl}/res/down/public/${this._gameName}/ks_${this._resVersion}/`);
                break;
            case EPlatformType.Gamebox4399:
                this._gameVersion = "0.0.1";
                this._resVersion = "0.0.1";
                platformData.appId = "ks667940122780561072";
                platformData.rewardVideoId = "230737_01";
                platformData.interstitialId = "230737_02";
                LTRespackManager.instance.SetRemoteUrl(`${this._remoteUrl}/res/down/public/${this._gameName}/gb_${this._resVersion}/`);
                break;
            case EPlatformType.HW:
                this._gameVersion = "0.0.1";
                this._resVersion = "0723";
                platformData.appId = "104360501";
                platformData.appKey = "104360501"; // "4593206c07a95b1edf85";
                //测试广告位
                platformData.bannerId = "j1pcnpx5tu";
                platformData.rewardVideoId = "e7hm5vx799";
                platformData.interstitialId = "testb4znbuh3n2";
                platformData.nativeinpageIds = ['u7m3hc4gvm'];
                // platformData.bannerId = "a3wlkri5qz";
                // platformData.rewardVideoId = "h2iup7j2ec ";
                // platformData.interstitialId = "c7xzj23ghu"; 
                // platformData.nativeinpageIds = ['u79peou9cx'];
                LTRespackManager.instance.SetRemoteUrl(`${this._remoteUrl}/res/down/public/${this._gameName}/hw_${this._resVersion}/`);
                break;
            default:
                console.error("未处理平台内容", LTPlatform.platformStr, "请在MainStart中添加处理");
                break;
        }
        if (platformData.appId) {
            this._appId = platformData.appId;
        }
    }
    _HandleSDK() {
        switch (LTPlatform.instance.platform) {
            case EPlatformType.Native_IOS:
            case EPlatformType.Native_Android:
            case EPlatformType.Native_Android_233:
            case EPlatformType.Native_IOS:
            case EPlatformType.Web4399:
                LTSDK.CreateInstace(SDK_Default, this._gameName, this._gameVersion, this._appId);
                break;
            default:
                LTSDK.CreateInstace(SDK_CQ, this._gameName, this._gameVersion, this._appId); //
                break;
        }
    }
    _InitFsm() {
        this._fsm.Add(new SplashScene());
        this._fsm.Add(new MainScene());
    }
}
